/* import __COLOCATED_TEMPLATE__ from './pick.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();